<template>
    <div>

        <div v-if="statusText" class="reg-text-notice">
            {{statusText}}
        </div>
        <form v-else class="main-page" @submit.prevent="sendData">

            <div class="main-page-nav">
                <div class="link"><router-link to="/login">Вход</router-link></div>
                <div class="divider">/</div>
                <div class="link"><router-link to="/register">Регистрация</router-link></div>
            </div>

            <material-input v-model="email" :error="authError" type="text">E-mail</material-input>

            <div style="text-align: center">
                <button type="submit">Восстановить</button>
            </div>

        </form>

    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    import axios from 'axios'
    import materialInput from '../../elements/material-input'

    export  default {
        components: {
            materialInput
        },
        data(){
            return {
                loading: false,
                valid: true,
                authError: '',
                email: '',
                statusText: '',
            }
        },
        methods: {
            sendData(){
                axios.post('/password/email',{
                    email: this.email,
                    // password: this.password,
                }).then((req)=>{
                    if(req.data.done){
                        this.statusText = req.data.status
                    }
                }).catch((req)=>{
                    let errors = req.response.data.errors;
                    if(errors){
                        this.authError = errors.email.join('\n');
                    } else {
                        this.authError = '';
                    }
                })
            }
        }
    }
</script>
